module.exports = __webpack_public_path__ + "img/flexsale_thumbnail.734e4f27.png";